module.exports = __webpack_public_path__ + "img/yiqi3.2ca7468b.png";